var map = {
	"./admin/UK/events.csv": [
		6674,
		6674
	],
	"./brother_marcus/UK/events.csv": [
		6821,
		6821
	],
	"./brother_marcus_south_ken/UK/events.csv": [
		5044,
		5044
	],
	"./honest_burger/UK/events.csv": [
		912,
		912
	],
	"./lina/UK/events.csv": [
		349,
		349
	],
	"./pizza_express/UK/events.csv": [
		6068,
		6068
	],
	"./sushi_dog/UK/events.csv": [
		2002,
		2002
	],
	"./tossed/UK/events.csv": [
		5365,
		5365
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5965;
module.exports = webpackAsyncContext;